import { react2angular } from 'react2angular';
import BrokerageList from './BrokeragesList';

angular
  .module('bb.answering')
  .component('bbBrokeragesList', react2angular(BrokerageList));
